import React, { useCallback } from 'react';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import SearchInput from '@decisiv/ui-components/lib/components/SearchInput';
import { H1 } from '@decisiv/ui-components/lib/components/Typography';

import { t } from '@lingui/macro';
import PageHead from 'components/PageHead';

import { useTeams } from './contexts/TeamsContext';
import CreateTeamModal from './CreateTeamModal';
import TeamModalProvider from './CreateTeamModal/contexts/TeamModalContext';
import { TeamsPageContent } from './TeamsPageContent';

export default function TeamsPage() {
  const { searchText, setSearchText } = useTeams();

  const handleSearchTextChange = useCallback(
    ({ target: { value } }) => {
      setSearchText(value);
    },
    [setSearchText],
  );

  return (
    <>
      <PageHead titleParts={[t`Teams`, t`Decisiv Super Admin`]} />

      <Flex>
        <Flex flex={1} paddingX={2} paddingY={1}>
          <Flex flex={1} alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <H1 weight="regular">{t`Teams`}</H1>
              <Flex flex={1} alignItems="center" marginLeft={2}>
                <SearchInput
                  size="small"
                  searchOn="change"
                  value={searchText}
                  onChange={handleSearchTextChange}
                  aria-label={t`Search for teams`}
                  helpMessage={t`Search by team name, team key, portal ID or owner email/username`}
                />
              </Flex>
            </Flex>
            <TeamModalProvider>
              <CreateTeamModal />
            </TeamModalProvider>
          </Flex>
        </Flex>
      </Flex>
      <Flex flexDirection="column" style={{ overflow: 'hidden' }}>
        <TeamsPageContent />
      </Flex>
    </>
  );
}
